export default __webpack_public_path__ + "static/media/mining.8697bc77.svg";